
import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { Pie, PieChart } from 'recharts';
import ShowAnsweredStatics from './ShowAnsweredStatics';

const Statics = () => {
    const getData  = useLoaderData()

    const data01 = [];

  getData.data.map((chart,index) => data01[index] = {"name" : chart.name, 'quiz' : chart.total} )    
    const data02 = [];

  getData.data.map((chart,index) => data02[index] = {"name" : chart.name, 'quiz' : chart.total} )    

const getTotal = getData.data.map((pre) => pre.total)

const totalQuiz = getTotal.reduce((pre, curr) => pre + curr, 0);
const getAns = JSON.parse(localStorage.getItem('answer'));
let allAnsweredItems = [];
if(getAns){
    for(const id in getAns){
      if(id.split('-')[0] === 'right'){
        const newId = parseInt(id.slice(-1));
        const getItem = getData.data.find(item => item.id == newId);
        if(getItem){
            allAnsweredItems.push({'name': getItem.name, 'totalQuiz': getItem.total, 'right': getAns[id] })
        }
      }
        
    }
}



    return (
        <div className='container py-5'>
                <div className="row">
                <div className="col-md-6 col-lg-3 col-sm-12">
                    <PieChart width={300} height={250}>
                        <Pie onClick={(e) => console.log(e.target)} data={data01} dataKey="quiz" nameKey="name" cx="50%" cy="50%" outerRadius={50} fill="#8884d8" />
                
                        <Pie data={data02} dataKey="quiz" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label />
                        </PieChart>
                        <h3 className="fw-bolder text-center">Total Quiz {totalQuiz}</h3>
                </div>
                <div className="col-md-6 col-lg-3 col-sm-12">
                    <PieChart width={300} height={250}>
                        <Pie onClick={(e) => console.log(e.target)} data={data01} dataKey="quiz" nameKey="name" cx="50%" cy="50%" outerRadius={50} fill="#8884d8" />
                
                        <Pie data={data02} dataKey="quiz" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label />
                        </PieChart>
                        <h3 className="fw-bolder text-center">Total Quiz {totalQuiz}</h3>
                </div>
                <div className="col-md-6 col-lg-3 col-sm-12">
                    <PieChart width={300} height={250}>
                        <Pie onClick={(e) => console.log(e.target)} data={data01} dataKey="quiz" nameKey="name" cx="50%" cy="50%" outerRadius={50} fill="#8884d8" />
                
                        <Pie data={data02} dataKey="quiz" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label />
                        </PieChart>
                        <h3 className="fw-bolder text-center">Total Quiz {totalQuiz}</h3>
                </div>
                <div className="col-md-6 col-lg-3 col-sm-12">
                    <PieChart width={300} height={250}>
                        <Pie onClick={(e) => console.log(e.target)} data={data01} dataKey="quiz" nameKey="name" cx="50%" cy="50%" outerRadius={50} fill="#8884d8" />
                
                        <Pie data={data02} dataKey="quiz" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label />
                        </PieChart>
                        <h3 className="fw-bolder text-center">Total Quiz {totalQuiz}</h3>
                </div>
               
                    </div>
                    <div className="row mt-5">
                        {
                            allAnsweredItems.map(staticItem => <ShowAnsweredStatics staticItem={staticItem} key={staticItem.name}></ShowAnsweredStatics>)
                        }
                    </div>
                </div>
    );
};

export default Statics;